// Convert kebab-case to camelCase
function toCamelCase(str) {
    return str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
}

// Format money from cents using Shopify's money format
// This function formats cents (number) to currency string
function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = Number(cents);
  
    const moneyFormat =
      format ||
      window.theme?.moneyFormat ||
      (window.Shopify && window.Shopify.money_format) ||
      '${{amount_with_comma_separator}}';
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number === null) return '0';
  
      const fixed = (number / 100).toFixed(precision);
      const [dollars, centsPart] = fixed.split('.');
      const dollarsWithThousands = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  
      return centsPart ? `${dollarsWithThousands}${decimal}${centsPart}` : dollarsWithThousands;
    }
  
    const placeholderMatch = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    const placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';
  
    let formatted;
  
    switch (placeholder) {
      case 'amount':
        formatted = formatWithDelimiters(value, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        formatted = formatWithDelimiters(value, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        formatted = formatWithDelimiters(value, 0, ' ', ',');
        break;
      default:
        formatted = formatWithDelimiters(value, 2, ',', '.');
    }
  
    return moneyFormat.replace(placeholderMatch[0], formatted);
  }

/**
 * Get processing text for button loading states
 * @returns {string} Processing text, translated if available
 */
function getProcessingText() {
  if (typeof window.t === 'function') {
    const translated = window.t('ui.processing');
    if (translated && translated !== 'ui.processing') return translated;
  }
  return 'Processing...';
}

/**
 * Show spinner on a button (replaces button content with spinner)
 * @param {HTMLButtonElement} button - The button element to show spinner on
 * @param {Object} [options={}] - Options object
 * @param {string} [options.spinnerClass='button-spinner'] - CSS class for the spinner
 * @returns {{originalText: string, originalWidth: string}|null} Object with original text and width (for restoring later), or null if button is invalid
 */
function showButtonSpinner(button, options = {}) {
  if (!(button instanceof HTMLButtonElement)) return null;
  
  const spinnerClass = options.spinnerClass || 'button-spinner';
  const originalText = button.textContent || '';
  
  // Store original width to prevent button from resizing
  const computedStyle = window.getComputedStyle(button);
  const originalWidth = button.style.width || computedStyle.width;
  
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.setAttribute('aria-label', originalText || getProcessingText());
  
  // Set width to prevent resizing when content changes
  if (originalWidth && originalWidth !== 'auto') {
    button.style.width = originalWidth;
    button.setAttribute('data-spinner-original-width', originalWidth);
  }
  
  button.innerHTML = `<span class="${spinnerClass}" aria-hidden="true"></span>`;
  
  return { originalText, originalWidth };
}

/**
 * Restore button from spinner state
 * @param {HTMLButtonElement} button - The button element to restore
 * @param {string|{originalText: string, originalWidth?: string}|null} originalData - Original text content, or object with originalText and originalWidth, or null
 */
function restoreButton(button, originalData) {
  if (!(button instanceof HTMLButtonElement)) return;
  
  // Handle both string (backward compatibility) and object formats
  const originalText = typeof originalData === 'string' 
    ? originalData 
    : (originalData && typeof originalData === 'object' && 'originalText' in originalData 
        ? originalData.originalText 
        : '');
  const storedWidth = button.getAttribute('data-spinner-original-width');
  
  button.disabled = false;
  button.removeAttribute('aria-busy');
  button.removeAttribute('aria-label');
  
  // Remove forced width if it was set
  if (storedWidth) {
    button.style.width = '';
    button.removeAttribute('data-spinner-original-width');
  }
  
  if (originalText) {
    button.textContent = originalText;
  }
} 

// Make functions available globally
if (typeof window !== 'undefined') {
    window.toCamelCase = toCamelCase;
    window.formatMoney = formatMoney;
    window.getProcessingText = getProcessingText;
    window.showButtonSpinner = showButtonSpinner;
    window.restoreButton = restoreButton;
}